import { render, staticRenderFns } from "./customerBack.vue?vue&type=template&id=1918177e&scoped=true"
import script from "./customerBack.vue?vue&type=script&lang=js"
export * from "./customerBack.vue?vue&type=script&lang=js"
import style0 from "./customerBack.vue?vue&type=style&index=0&id=1918177e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1918177e",
  null
  
)

export default component.exports